import { render, staticRenderFns } from "./VictorinoxDetails.vue?vue&type=template&id=71118ee0"
import script from "./VictorinoxDetails.vue?vue&type=script&lang=js"
export * from "./VictorinoxDetails.vue?vue&type=script&lang=js"
import style0 from "./VictorinoxDetails.vue?vue&type=style&index=0&id=71118ee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports